import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import * as K from 'common/constants';
import { TOKEN_TYPE } from 'common/util/filter/types';
import { truncateText } from 'common/util/string';

import SeeMoreDialog from 'components/common/Dialog/SeeMoreDialog';
import Page from 'components/common/Page/Page';
import { completeFilterState } from 'components/common/Managers/RouteStateManager.state';
import { ViewStateManager } from 'components/common/Managers/ViewStateManager';
import SearchToolbar from 'components/search/SearchToolbar';
import LoglineSelectionPopover from 'components/search/SearchLogsPage/LoglineSelectionPopover';
import SearchLogsResultsArea from 'components/search/SearchLogsPage/SearchLogsResultsArea';
import SearchStateManager from 'components/search/SearchLogsPage/SearchStateManager';

import './SearchLogsPage.scss';

/**
 * The Search Logs Page allows the user to search logs for a given time span and filter.
 * It shows the results in a timeline, as facets that can be explored, and as log lines.
 */
function SearchLogsPage() {

  const completeFilter = useRecoilValue(completeFilterState);
  const title = truncateText(completeFilter, K.TITLE_MAX_LENGTH) || 'Search';

  const excludeTypes = useMemo(() => [ TOKEN_TYPE.COMMAND, TOKEN_TYPE.FUNCTION ], []);

  return (
    <Page docTitle={title} type="full">
      <SearchStateManager />
      <ViewStateManager />
      <SearchToolbar excludeTypes={excludeTypes} />
      <div className="SearchLogs__ResultsArea">
        <SearchLogsResultsArea />
      </div>
      <LoglineSelectionPopover />
      <SeeMoreDialog />
    </Page>
  );
}

export default SearchLogsPage;
